import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE02003S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>제품소개</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
                    <a href="#none" onClick={toggleDropdown}>
                     무수익채권(NPL)관리<span></span>
                    </a>
				    <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                        <li>
                            <Link to="/GNBPURE02001S">온라인대출</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02002S">스탁론</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02003S">NPL</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02004S">기관연계시스템</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02000S">통합솔루션</Link>
                        </li>
                    </ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>무수익채권(NPL)관리</h3>

                    <article> 
                        <p className="subtitle">NPL시스템</p>
                        <p className="txt-wrap">
                            NPL 시스템은 20년 이상의 필드 경험과 노하우를 바탕으로 개발된 시스템으로, 법조치 업무를 프로세스화하고, 
                            동반된 법조치 비용을 효과적으로 관리합니다. 
                            또한, 회계 시스템과의 연동을 통해 시스템 통합을 완성하고 신용관리사의 추심 활동 현황을 체계적으로 관리할 수 있습니다. 
                            이를 통해 추심 방향성을 제시해 줄 수 있는 기반을 마련했습니다.
                        </p>
                    </article> 
                    <article className="pc">
                        <div className="subtitle">시스템개요</div>
                        <div className="table-type table-col">
                            <table>
                                <caption>시스템개요</caption>
                                <colgroup>
                                    <col style={{width: "25%"}}/>
                                    <col style={{width: "25%"}}/>
                                    <col style={{width: "25%"}}/>
                                    <col style={{width: "*"}}/>
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope="col">기획</th>
                                        <th scope="col">법무</th>
                                        <th scope="col">지원</th>
                                        <th scope="col">신관사</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>채권배정</li>
                                                <li>목표설정관리</li>
                                                <li>수수료관리</li>
                                                <li>민원관리</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>법조치진행</li>
                                                <li>집행사건관리</li>
                                                <li>시효관리</li>
                                                <li>변론관리</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>법원문서스캔</li>
                                                <li>사건기일등록</li>
                                                <li>부채증명서발행</li>
                                                <li>채무종결확인서발행</li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>전화발신</li>
                                                <li>DM발송</li>
                                                <li>방문활동</li>
                                                <li>채무조정</li>
                                                <li>법조치품의</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </article>
                    
                    <article className="mo">
                        <div className="subtitle">시스템 개요</div>
                        <div className="table-type table-row">
                            <table>
                                <caption>NPL시스템 개요</caption>
                                <colgroup>
                                    <col style={{width: "36%"}}/>
                                    <col style={{width: "*"}}/>
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th scope="row">기획</th>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>채권배정</li>
                                                <li>목표설정관리</li>
                                                <li>수수료관리</li>
                                                <li>민원관리</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">법무</th>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>법조치진행</li>
                                                <li>집행사건관리</li>
                                                <li>시효관리</li>
                                                <li>변론관리</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">지원</th>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>법원문서스캔</li>
                                                <li>사건기일등록</li>
                                                <li>부채증명서발행</li>
                                                <li>채무종결확인서발행</li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">신관사</th>
                                        <td>
                                            <ul className="bul-dot">
                                                <li>전화발신</li>
                                                <li>DM발송</li>
                                                <li>방문활동</li>
                                                <li>채무조정</li>
                                                <li>법조치품의</li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </article>
                    <article>
                        <div className="subtitle">기대효과</div>
                        <img src="/asset/img/subB/img_npl1.png" alt="인터넷 대출시스템" className="img-sub pc" />
                        <img src="/asset/img/subB/img_npl1_mo.png" alt="인터넷 대출시스템" className="mt10 mo" />
				    </article>
			  </div>
			</div>
		  </div>



		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE02003S;
